import OfferBookConsultationButton from '@components/Button/OfferBookConsultationButton';
import OfferContactDialogForm from '@components/Dialog/OfferContactDialogForm';
import { Alert, Button } from '@eye-able/ui';
import { SendIcon } from 'lucide-react';
import type { ComponentProps, ReactNode } from 'react';
import {
  type TranslationNode,
  useInlineTranslation,
} from '@/i18n/hooks/useInlineTranslation.tsx';
import { T } from '@/i18n/T';

// Shared product upsell alert.

interface ProductOfferAlertProps {
  product: TranslationNode;
  beforeText?: ReactNode;
  children?: ReactNode;
  hidden?: boolean;
  title?: ReactNode;
  variant?: ComponentProps<typeof Alert>['variant'];
}

export default function ProductOfferAlert({
  product,
  beforeText = '',
  children,
  hidden = false,
  title,
  variant = 'info',
}: ProductOfferAlertProps) {
  const { t, text } = useInlineTranslation();
  const productText = text(product);

  if (hidden) return null;

  return (
    <Alert
      variant={variant}
      title={
        <div className='eye:flex eye:flex-col eye:gap-2xs'>
          {beforeText && <div>{beforeText}</div>}

          {title ?? (
            <T
              k='featureOfferBoxCallToAction'
              options={{ product: productText }}
            />
          )}
        </div>
      }
    >
      {children}
      <div className='eye:mt-2xs eye:flex eye:flex-wrap eye:gap-xs'>
        <OfferContactDialogForm
          product={productText}
          trigger={
            <Button variant='outline'>
              <SendIcon aria-hidden='true' />
              {t('OfferContactFormButton')}
            </Button>
          }
        />
        <OfferBookConsultationButton />
      </div>
    </Alert>
  );
}
